// extracted by mini-css-extract-plugin
module.exports = {"totalResultsDescription":"styles__totalResultsDescription___3eQSK"};